import React, { Suspense, useRef, useEffect } from "react";
import { Canvas as CanvasBase, useLoader, useFrame } from "@react-three/fiber";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Canvas = CanvasBase as any;
import { STLLoader } from "three-stdlib";
import { Vector3, Mesh } from "three";

interface StlThumbnailPreviewProps {
	url: string;
}

const STLThumbnail: React.FC<{ stlUrl: string }> = ({ stlUrl }) => {
	const ref = useRef<Mesh>(null);
	const geometry = useLoader(STLLoader, stlUrl);

	// Center and scale the model on load
	useEffect(() => {
		if (geometry && ref.current) {
			geometry.computeBoundingBox();
			const boundingBox = geometry.boundingBox!;
			const center = new Vector3();
			boundingBox.getCenter(center);
			geometry.translate(-center.x, -center.y, -center.z);

			const size = boundingBox.getSize(new Vector3());
			const maxDim = Math.max(size.x, size.y, size.z);
			const scale = 2.5 / maxDim;
			ref.current.scale.setScalar(scale);
		}
	}, [geometry]);

	// Cleanup on unmount
	useEffect(() => {
		return () => {
			if (geometry) {
				geometry.dispose();
			}
		};
	}, [geometry]);

	return (
		<mesh ref={ref} geometry={geometry}>
			<meshStandardMaterial
				color="#ff6b35"
				metalness={0.3}
				roughness={0.5}
			/>
		</mesh>
	);
};

export const StlThumbnailPreview: React.FC<StlThumbnailPreviewProps> = ({ url }) => {
	return (
		<Canvas
			style={{ height: "100%", width: "100%" }}
			camera={{ position: [3, 3, 3], fov: 60 }}
			gl={{ antialias: false, alpha: true }}
			dpr={1}
		>
			<ambientLight intensity={0.6} />
			<directionalLight
				intensity={0.8}
				position={[5, 5, 5]}
			/>
			<Suspense fallback={null}>
				<STLThumbnail stlUrl={url} />
			</Suspense>
		</Canvas>
	);
};